import { Message } from './Message';



export class ReadQuery extends Message
{
    constructor(Id: string)
    {
        super("Read", { Id });
    }
}
